export const EMAIL = 'sales@tekwashsystems.com';
export const PHONE = '+91 9960816769';
export const PHONE_INTL = '919960816769';
export const ADDRESS = 'No 15, Sr No 91/1/16, Ragad Shikshak Nagar, Kothrud, Pune 411038';

export const waLink = (text) =>
  `https://wa.me/${PHONE_INTL}?text=${encodeURIComponent(text)}`;

export const img = (name) => `/machines/${name}`;

export const stats = [
  { value: '12+', label: 'Years in component cleaning', testid: 'stat-years' },
  { value: '2000 m²', label: 'Production facility, Pune', testid: 'stat-facility' },
  { value: '<2 mg', label: 'Millipore / 1000 cm² precision target', testid: 'stat-millipore' },
  { value: '30 s', label: 'SPM cycle per component', testid: 'stat-cycle' }
];

export const products = [
  {
    id: 'rotary-table',
    name: 'Rotary Table Washers',
    tagline: 'Indexing rotary tables with component-specific fixtures',
    desc: 'Rotary table and rotary indexing washers for repeatable, cycle-timed batch and single-piece-flow cleaning. Components are loaded in dedicated fixtures or baskets and rotate through wash, rinse and blow-off stations.',
    bullets: ['Rotary table & rotary indexing variants', 'Dedicated component fixtures & baskets', 'Spray, flood and spin-dry stations', 'Compact footprint for cell layouts'],
    chips: ['Spray Wash', 'Flood Wash', 'Air Blow-off'],
    images: ['rotary-1.jpg', 'rotary-2.jpg', 'rotary-3.jpg', 'rotaryclean-1.jpg']
  },
  {
    id: 'cabinet',
    name: 'Cabinet Washers',
    tagline: 'Enclosed front-loaded cabinets for bins & batches',
    desc: 'Front-loaded cabinet washers for Plastic bins, miscellaneous manufactured components and batch cleaning. Enclosed spraying keeps operator exposure and heat loss low while delivering uniform coverage.',
    bullets: ['Enclosed cabinet construction', 'Basket & bin loading options', 'Uniform nozzle coverage', 'Low running cost & maintenance'],
    chips: ['Batch Wash', 'Bin Cleaning', 'Hot Air Dry'],
    images: ['cabinet-1.jpg', 'cabinet-2.jpg', 'cabinet-2.jpg', 'cabinet-1.jpg']
  },
  {
    id: 'spm-compact',
    name: 'SPM Compact High-Pressure Washer',
    tagline: 'The 30-second precision washer for cell layouts',
    desc: 'Our flagship special-purpose machine: a compact high-pressure washer engineered for throttle bodies and precision components. Dedicated wash and airblow zones deliver reliable, Millipore-verified cleanliness in a 0.6 × 1.5 m footprint.',
    bullets: ['Compact footprint — 0.6 × 1.5 m approx.', 'Complete S.S. 304 construction', '30 sec cycle time per component', 'Dedicated washing & airblow zones', '4-stage filtration system', 'Less running cost & low maintenance', 'Fits cell layout — no skilled operator required'],
    chips: ['15 bar Spray', 'Compressed Airblow', '4-Stage Filtration'],
    images: ['spm-hero.jpg', 'spm-2.jpg', 'spm-3.jpg', 'spm-detail.jpg']
  },
  {
    id: 'front-load',
    name: 'Front Load / Unload Washers',
    tagline: 'Operator-friendly front-loaded precision cleaning',
    desc: 'Front load/unload washers with slide-out loading tables for safe, ergonomic handling of machined components. Ideal for final-assembly-ready cleanliness on engine and transmission parts.',
    bullets: ['Ergonomic front load / unload', 'Fixture-based component holding', 'Multi-stage wash & dry zones', 'Reliable cleanliness results'],
    chips: ['Spray Wash', 'Rinse', 'Hot Air Dry'],
    images: ['frontload-1.jpg', 'frontload-2.jpg', 'frontload-3.jpg', 'frontload-4.jpg']
  },
  {
    id: 'through-feed',
    name: 'Through-Feed Washers',
    tagline: 'Continuous multistage conveyor cleaning lines',
    desc: 'Conveyorised through-feed systems for high-volume component flow. Multistage tunnels combine washing, rinsing and drying zones with tiered filtration for continuous production lines.',
    bullets: ['Continuous conveyor through-feed', 'Multistage wash / rinse / dry tunnels', 'Multi-tier filtration & bath management', 'Suits high-volume line integration'],
    chips: ['Conveyorised', 'Multistage', 'Continuous Flow'],
    images: ['throughfeed-1.png', 'throughfeed-2.png', 'throughfeed-3.png', 'throughfeed-4.jpg']
  },
  {
    id: 'multi-chamber',
    name: 'Multi-Chamber Cleaning Systems',
    tagline: 'Chambered immersion & spray lines for complex geometry',
    desc: 'Multi-chamber systems that move components through dedicated immersion flood, spray and ultrasonic chambers — engineered for complex geometries and demanding specification targets.',
    bullets: ['Dedicated wash / rinse / dry chambers', 'Immersion flood & spray combinations', 'Multistage process control', 'Custom chamber sequencing'],
    chips: ['Immersion', 'Multistage', 'Custom Build'],
    images: ['multichamber-1.jpg', 'multichamber-2.jpg', 'throughfeed-2.png', 'throughfeed-3.png']
  },
  {
    id: 'ultrasonic',
    name: 'Ultrasonic Cleaning Machines',
    tagline: 'Cavitation cleaning for intricate passageways',
    desc: 'Ultrasonic cleaning systems that use cavitation waves to reach bores, galleries and internal passages that spray alone cannot. Available as standalone tanks or integrated multistage lines.',
    bullets: ['Immersion & ultrasonic waves', 'Reaches internal passages & bores', 'Standalone tanks or inline systems', 'Combined with flood wash & rinsing'],
    chips: ['Ultrasonic', 'Immersion', 'Precision'],
    images: ['ultrasonic-1.jpg', 'ultrasonic-2.jpg', 'spm-detail.jpg', 'ultrasonic-1.jpg']
  },
  {
    id: 'robotic',
    name: 'Robotic Cleaning Cells',
    tagline: 'Robot-guided 100–1000 bar precision cleaning',
    desc: 'Fully automatic robotic cells where a robot guides high-pressure lances (100–1000 bar) over complex components — targeted deburring, pinpoint flushing and multi-process drying including vacuum drying.',
    bullets: ['Robot-guided high-pressure cleaning', '100–1000 bar targeted deburring & flushing', 'Multi-process drying incl. vacuum drying', 'Fully automatic, cutting-edge systems'],
    chips: ['Robotic', '100–1000 bar', 'Vacuum Drying'],
    images: ['robotic.jpg', 'robotic-sim.png', 'handling-2.jpg', 'handling-1.jpg']
  },
  {
    id: 'tailor-made',
    name: 'Tailor-Made SPMs',
    tagline: 'Custom special-purpose machines built to your component',
    desc: 'When a standard machine will not do, we engineer the machine around your component — custom fixtures, nozzle manifolds, pressures and automation, from concept drawing to commissioning.',
    bullets: ['Component-specific engineering', 'Custom fixtures & nozzle manifolds', 'Concept to commissioning in-house', 'Designed in Solid Edge, AutoCAD & Eplan'],
    chips: ['Custom', 'SPM', 'Concept-to-Build'],
    images: ['custom-1.jpg', 'custom-2.jpg', 'custom-3.jpg', 'custom-4.jpg']
  },
  {
    id: 'automation',
    name: 'Material Handling Automation',
    tagline: 'Pick & place, conveyors, lifters, turntables & more',
    desc: 'Complete material handling automation around our washers — pick and place systems, conveyors, lifters, turn-over devices and turntables — so cleaned components flow hands-free to your line.',
    bullets: ['Pick & place systems', 'Conveyors & lifters', 'Turn-over devices & turntables', 'Line integration with washing systems'],
    chips: ['Pick & Place', 'Conveyors', 'Turntables'],
    images: ['handling-1.jpg', 'handling-2.jpg', 'handling-3.jpg', 'handling-4.jpg']
  }
];

export const spmSpotlight = {
  name: 'SPM Type Compact High-Pressure Washer',
  images: ['spm-hero.jpg', 'spm-2.jpg', 'spm-3.jpg', 'spm-detail.jpg'],
  specs: [
    ['Footprint', '0.6 × 1.5 m approx.'],
    ['Construction', 'Complete S.S. 304'],
    ['Cycle time', '30 sec per component'],
    ['Washing', 'High-pressure spray wash @ 15 bar'],
    ['Drying', 'Dedicated compressed airblow'],
    ['Filtration', '4-stage filtration system'],
    ['Layout', 'Fits cell layout — no skilled operator required'],
    ['Achieved cleanliness', '1.29 mg / 1.15 mg — particle size < 300 µm (throttle bodies)']
  ],
  features: [
    'Individual fixtures per component',
    '360° component rotation',
    'Nylon coating on contact areas',
    'Dedicated wash nozzles',
    'Special airblow nozzles',
    'Non-metallic fixture pads'
  ]
};

export const cleaningLevels = [
  {
    num: '01',
    name: 'Basic Cleaning',
    tagline: 'Intermediate cleaning for rough parts',
    points: [
      'Manual spray or immersion cleaning',
      'Drying by evaporation, component rotation & run-off',
      'Basic or no filtration system; water / energy reuse',
      'High cycle time — suitable only as intermediate cleaning'
    ],
    measurement: ['Visual check for contaminants', 'No collection of water']
  },
  {
    num: '02',
    name: 'Quality Cleaning',
    tagline: 'Automated, assembly-ready cleaning',
    points: [
      'Automated machine cleaning by spray (5–20 bar) or immersion & ultrasonic waves',
      'Drying by forced hot or cold air blow',
      'Multi-tier filtration system',
      'Cycle time between 2–10 min — component ready for final assembly / painting'
    ],
    measurement: ['Component ready for assembly', 'No water droplets or solution traces']
  },
  {
    num: '03',
    name: 'Precision Cleaning',
    tagline: 'Robotic, Millipore-verified cleanliness',
    points: [
      'Targeted high-pressure cleaning (100–1000 bar), usually with robots',
      'Multi-process drying including vacuum drying',
      'Multi-tier filtration system & absolute filters',
      'Low cycle time in spite of complex component geometry'
    ],
    measurement: ['Millipore values < 2 mg / 1000 cm²', 'Particle count for size < 300 µm', '100% dry component']
  }
];

export const washingProcesses = [
  'Spray Washing', 'Specific Butting & Flushing', 'Immersion Flood Washing',
  'Ultrasonic Washing', 'High Pressure Deburring', 'Dunking'
];

export const dryingProcesses = [
  'Compressed Airblow', 'High Pressure Airblow', 'Hot Airblow',
  'Component Rotation', 'Vacuum Drying'
];

export const industries = [
  {
    id: 'two-wheeler',
    name: 'Two-Wheeler',
    components: ['Cylinder Block', 'Cylinder Head', 'Crank Shaft', 'Cam Shaft', 'Connecting Rod', 'Crank Case', 'Gears & Shafts', 'Miscellaneous Components']
  },
  {
    id: 'passenger',
    name: 'Passenger Vehicle',
    components: ['Cylinder Block', 'Cylinder Head', 'Crank Shaft', 'Cam Shaft', 'Connecting Rod', 'Crank Case', 'Gear Box Housing', 'Gears & Shafts', 'Axle Hub & Housing', 'Banjo Beam', 'Brake Drum & Hub', 'Plastic Bins']
  },
  {
    id: 'commercial',
    name: 'Commercial Vehicle',
    components: ['Cylinder Block', 'Cylinder Head', 'Crank Shaft', 'Cam Shaft', 'Connecting Rod', 'Gear Box Housing', 'Gears & Shafts', 'Axle Hub & Housing', 'Front Axle Beam', 'Brake Drum & Hub', 'Plastic Bins']
  },
  {
    id: 'other',
    name: 'Other Industry',
    components: ['Compressor Parts', 'Roller Beams & Axle Boxes of Locomotives', 'Wind Turbine Components', 'Miscellaneous Manufactured Components']
  }
];

export const servicePipeline = [
  { step: '01', title: 'Conceptualization', desc: 'Component analysis & cleaning concept' },
  { step: '02', title: 'Engineering', desc: 'Design in Solid Edge, AutoCAD & Eplan' },
  { step: '03', title: 'Programming', desc: 'Control & automation programming' },
  { step: '04', title: 'Production', desc: 'Manufactured at our 2000 m² Pune facility' },
  { step: '05', title: 'Installation', desc: 'On-site erection & commissioning across India' },
  { step: '06', title: 'Service', desc: '3 dedicated service engineers, spares & training' }
];

export const marqueeItems = [
  'AUTOMOTIVE OEMS', 'TWO-WHEELER', 'PASSENGER VEHICLES', 'COMMERCIAL VEHICLES',
  'MILLIPORE < 2 MG', '100–1000 BAR ROBOTIC', 'SS 304 CONSTRUCTION', '30 SEC CYCLE', 'PUNE, INDIA'
];
